import type { Client, RequestContext } from "../client";
import type { FeaturesConfigurationResource } from "../resources/featuresConfigurationResource";
import { ConfigurationRepository } from "./configurationRepository";
export class FeaturesConfigurationRepository extends ConfigurationRepository<FeaturesConfigurationResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("FeaturesConfiguration", client, requestContext);
    }
}
